export const AGENCY_LIST = 'AGENCY_LIST'; 
export const SELECTED_AGENCY = 'SELECTED_AGENCY';